var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVybrntBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 21,
    viewBox: "0 0 125 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8085 18.9756H7.89253L1.75586 2.14355H6.15183L9.9067 14.0779H9.99891L13.7311 2.14355H18.0595L11.8085 18.9756Z",
    fill: "#0D2645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9925 11.8439V18.9756H29.0767V11.8439L22.9854 2.14355H27.7262L31.1837 8.37237L34.6417 2.14355H39.2214L32.9925 11.8439Z",
    fill: "#0D2645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6197 18.9756H46.1621V2.14355H52.6197C55.1392 2.14355 58.138 3.07166 58.138 6.47073C58.138 8.32509 57.0617 9.56084 55.4821 10.1081V10.1555C57.3371 10.4883 58.803 11.8679 58.803 14.0779C58.803 17.7398 55.7114 18.9756 52.6197 18.9756ZM51.8636 5.37681H49.9403V8.84837H52.0461C53.5121 8.84837 54.3597 8.2059 54.3597 7.018C54.3603 5.8768 53.5128 5.37681 51.8636 5.37681ZM52.1157 11.8439H49.9403V15.6944H52.139C53.375 15.6944 54.8871 15.3388 54.8871 13.6982C54.8871 12.2948 53.7874 11.8439 52.1157 11.8439Z",
    fill: "#0D2645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.797 18.9756L72.2931 12.2954H70.9638V18.9756H67.1172V2.14355H73.2995C76.4149 2.14355 79.5051 3.38063 79.5051 7.23112C79.5051 9.49027 78.2242 11.1063 76.1397 11.7721L80.3756 18.975H75.797V18.9756ZM73.0257 5.42473H70.9413V9.34709H72.7963C74.056 9.34709 75.6359 9.01421 75.6359 7.30303C75.6359 5.73431 74.1932 5.42473 73.0257 5.42473Z",
    fill: "#0D2645"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3308 18.9756L91.8044 7.96885H91.7354L91.8269 18.9756H88.0254V2.14355H92.4919L98.9945 13.127H99.0641L98.9719 2.14355H102.775V18.975H98.3308V18.9756Z",
    fill: "#0D2645"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.783 5.61514V18.975H114.868V5.61514H110.287V2.14355H123.362V5.61514H118.783Z",
    fill: "#0D2645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVybrntBlueLogo);
export default __webpack_public_path__ + "static/media/vybrnt-blue-logo.cbc42820995db20735fddcb0cb4a2059.svg";
export { ForwardRef as ReactComponent };